module.exports = __webpack_public_path__ + "img/youtube_white.0c063b89.svg";